import styled from 'styled-components/macro';
import { SIZE } from 'assets/styles/ScreenSize';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const StyledContent = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenColumn}
  width: 100%;
  height: 100%;
  max-width: 1200px;
  height: auto;
  margin: auto;
  position: relative;
  z-index: 1;
  border-radius: 10px;
  background: linear-gradient(
    155.67deg,
    rgba(255, 255, 255, 0.59) -7.08%,
    rgba(255, 255, 255, 0.13) 110.41%
  );
  border: 1px solid rgba(15, 66, 90, 0.33);
  box-shadow: 0 4px 24px -1px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(20px);
  margin-top: 130px;
  margin-bottom: 65px;
  @media (min-width: ${SIZE.mobile}) {
    padding: 18px 17px 38px;
    width: 285px;
    height: 600px;
  }

  @media (min-width: ${SIZE.iphone}) {
    padding: 16px 17px 68px;
    width: 366px;
    height: 600px;
  }

  @media (min-width: ${SIZE.tablet}) {
    padding: 24px 25px 45px;
    width: 579px;
    height: 600px;
  }

  @media (min-width: ${SIZE.desktopS}) {
    padding: 18px 25px 44px;
    width: 849px;
    height: 600px;
  }

  @media (min-width: ${SIZE.desktop}) {
    padding: 21px 34px 71px;
    width: 1200px;
  }

  .MuiPaper-root {
    background: transparent;
  }

  .MuiStepper-root {
    padding: 0;
  }

  .MuiStepLabel-iconContainer {
    padding: 0;
  }

  .MuiStep-horizontal {
    padding: 0;
    height: 36px;
  }

  .MuiStepConnector-line {
    background: ${COLORS.darkGray};
  }

  .MuiStepConnector-root {
    @media (min-width: ${SIZE.mobile}) {
      margin-top: -25px;
    }

    @media (min-width: ${SIZE.iphone}) {
      margin-top: -20px;
    }

    @media (min-width: ${SIZE.tablet}) {
      margin-top: -16px;
    }

    @media (min-width: ${SIZE.desktop}) {
      margin-top: -5px;
    }

    @media (min-width: ${SIZE.bigDesktop}) {
      margin-top: 0;
    }
  }

  .button-active-style {
    background: ${COLORS.mainColor};
    color: ${COLORS.white};
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 400px;
`;

export const StyledQuestionsPage = styled.div`
  ${FLEX_CONTAINER.FlexCenterColumn};
  position: relative;
  height: 100%;

  .footer {
    margin-top: 50px;
  }
`;
